import { ContentfulEntryType } from './contentful-entry.type';

export class TopicType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get description(): string {
    return this.fields['description'];
  }

  public get example(): string {
    return this.fields['example'];
  }

  public get subject(): Array<string> {
    return this.fields['subject'];
  }

}


